export const categories = [
  {
    id: 'dianshi',
    name: '电视剧',
    slug: 'dianshi',
    icon: 'ri-tv-line',
    description: '海量热门电视剧，追剧不停歇',
    count: 1280,
  },
  {
    id: 'dianying',
    name: '电影',
    slug: 'dianying',
    icon: 'ri-film-line',
    description: '精选国内外高分电影',
    count: 2560,
  },
  {
    id: 'zongyi',
    name: '综艺',
    slug: 'zongyi',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目，欢笑不断',
    count: 890,
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    icon: 'ri-ghost-line',
    description: '热血动漫、经典番剧一网打尽',
    count: 1640,
  },
  {
    id: 'duanshipin',
    name: '短视频',
    slug: 'duanshipin',
    icon: 'ri-vidicon-line',
    description: '精彩短视频，碎片时间的最佳伴侣',
    count: 3500,
  },
  {
    id: 'jilu',
    name: '纪录片',
    slug: 'jilu',
    icon: 'ri-earth-line',
    description: '探索世界，发现未知的精彩',
    count: 720,
  },
  {
    id: 'tiyu',
    name: '体育',
    slug: 'tiyu',
    icon: 'ri-basketball-line',
    description: '赛事集锦、体育资讯实时更新',
    count: 560,
  },
  {
    id: 'yinyue',
    name: '音乐',
    slug: 'yinyue',
    icon: 'ri-music-line',
    description: 'MV、演唱会、音乐现场',
    count: 930,
  },
];

export const categorySlugMap: Record<string, string> = {
  dianshi: '电视剧',
  dianying: '电影',
  zongyi: '综艺',
  dongman: '动漫',
  duanshipin: '短视频',
  jilu: '纪录片',
  tiyu: '体育',
  yinyue: '音乐',
};